document.addEventListener('DOMContentLoaded', function () {
    (function() {
        const moveCustomText = () => {
            const elementToMove = document.querySelector('div#CustomText-custom_text_KQNP4V');
            const targetElement = document.querySelector('.icon-with-text.list-unstyled');

            if (elementToMove && targetElement) {
                if (elementToMove.previousElementSibling !== targetElement) {
                    targetElement.parentNode.insertBefore(elementToMove, targetElement.nextSibling);
                    console.log('Elemento movido para baixo dos ícones');
                }
            }
        };

        moveCustomText();

        const observer = new MutationObserver(() => {
            moveCustomText();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    })();
});